interface PropTypes {
    width?: number;
    height?: number;
}

const AlertIcon = ({ width = 10, height = 12 }: PropTypes) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.0002 0.5C12.6658 0.5 13.2799 0.851562 13.6174 1.42812L23.7424 18.6781C24.0846 19.2594 24.0846 19.9766 23.7518 20.5578C23.419 21.1391 22.7955 21.5 22.1252 21.5H1.87522C1.20491 21.5 0.581473 21.1391 0.24866 20.5578C-0.084152 19.9766 -0.0794645 19.2547 0.258035 18.6781L10.383 1.42812C10.7205 0.851562 11.3346 0.5 12.0002 0.5ZM12.0002 6.5C11.3768 6.5 10.8752 7.00156 10.8752 7.625V12.875C10.8752 13.4984 11.3768 14 12.0002 14C12.6237 14 13.1252 13.4984 13.1252 12.875V7.625C13.1252 7.00156 12.6237 6.5 12.0002 6.5ZM13.5002 17C13.5002 16.6022 13.3422 16.2206 13.0609 15.9393C12.7796 15.658 12.398 15.5 12.0002 15.5C11.6024 15.5 11.2209 15.658 10.9396 15.9393C10.6583 16.2206 10.5002 16.6022 10.5002 17C10.5002 17.3978 10.6583 17.7794 10.9396 18.0607C11.2209 18.342 11.6024 18.5 12.0002 18.5C12.398 18.5 12.7796 18.342 13.0609 18.0607C13.3422 17.7794 13.5002 17.3978 13.5002 17Z"
                fill="#F7D44F"
            />
        </svg>
    );
};

export default AlertIcon;
